"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyGenerateARandomVoiceV1VoiceGenerationGenerateVoicePostGender = void 0;
exports.BodyGenerateARandomVoiceV1VoiceGenerationGenerateVoicePostGender = {
    Female: "female",
    Male: "male",
};
